import React from 'react';
import { Helmet } from 'react-helmet';
import { useSelector } from 'react-redux';
import Title from '../../../../components/Title';
import { oneClient } from '../../../../redux/slices/clientsSlice';
import PageNavigation from './PageNavigation';
import { Outlet } from 'react-router-dom';

export default function CrmSubPage() {
    const client = useSelector(oneClient);

    return (
        <div>
            <Helmet>
                <title>{`Console Defentry - Clients - ${client.name} - CRM`}</title>
            </Helmet>
            <Title isSubPageTitle>CRM</Title>

            <div className="navigation-tabs__bottom-indent-wrapper--24">
                <PageNavigation />
            </div>
            <Outlet />
        </div>
    );
}
